import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../_actions/dataActions";
import PageSubTitle from "../../../UI/PageSubTitle";
import EditWidget from "../../../UI/EditWidget";
import Wrapper from "../../../../_hoc/Wrapper";
import Select from "../../../UI/Select";
import Data from "../../../../_data";
import getCountry from "../../../../_selectors/dataSelectors/getCountry";
import getState from "../../../../_selectors/dataSelectors/getState";
import getMyPartnerPreferenceLocationDetail from "../../../../_selectors/userSelectors/getMyPartnerPreferenceLocationDetail";

class Location extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.preference) {
      const { country, state } = nextProps.preference;
      const { selectedCountry, selectedState, isEditModeOn } = prevState;
      if (isEditModeOn) {
        return null;
      } else {
        if (
          country !== prevState.selectedCountry ||
          state !== prevState.selectedState
        ) {
          return {
            selectedCountry: country,
            selectedState: state
          };
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  state = { isEditModeOn: false, selectedCountry: [], selectedState: [] };
  componentDidMount() {
    const { country, getCountryData, preference, getStateData } = this.props;
    if (country.length === 0) {
      getCountryData();
    }
    if (preference.country.length !== 0) {
      getStateData(preference.country);
    }
  }
  componentDidUpdate(prevProps) {
    const { getStateData } = this.props;
    if (prevProps.preference) {
      if (
        prevProps.preference.country.length !==
        this.props.preference.country.length
      ) {
        getStateData(this.props.preference.country);
      }
    }
  }
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  save = () => {
    const { selectedCountry, selectedState } = this.state;
    const { update } = this.props;
    const updatedPreference = {
      country: selectedCountry,
      state: selectedState
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
    };
    const onError = err => {
      console.log(err);
    };
    update({ data: updatedPreference, onSuccess, onError });
  };
  render() {
    const { isEditModeOn, selectedCountry, selectedState } = this.state;
    const { country, state, getStateData } = this.props;
    return (
      <Wrapper>
        <PageSubTitle>
          <h3>
            Location Preference
            <EditWidget
              show
              edit={isEditModeOn}
              onEdit={this.enableEditMode}
              onSave={this.save}
              onCancel={this.disableEditMode}
              disabled={false}
            />
          </h3>
          <p />
        </PageSubTitle>
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-6">
              <Select
                label={<Wrapper>Country</Wrapper>}
                selected={selectedCountry}
                options={country}
                onChange={value => {
                  this.setState({ selectedCountry: value }, () => {
                    getStateData(value);
                  });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-6">
              <Select
                label={<Wrapper>State</Wrapper>}
                selected={selectedState}
                options={state}
                onChange={value => {
                  this.setState({ selectedState: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  country: getCountry(state),
  state: getState(state),
  preference: getMyPartnerPreferenceLocationDetail(state)
});
const mapDispatchToProps = dispatch => ({
  getCountryData: () => dispatch(dataActions.getCountry()),
  getStateData: country => dispatch(dataActions.getStateByCountry(country))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Location);



// WEBPACK FOOTER //
// ./src/_components/Profile/PartnerPreference/Location/index.js